export default class UIMessages {
  public static common = class {
    public static all = 'All'
    public static issues = 'Issues'
    public static NewRequest = 'New Request'
    public static backToList = 'Back to List'
    public static editDetails = 'Edit Details'
    public static confirmationMessage = 'Confirmation Message'
    public static saveDetails = 'Save'
    public static total = 'Total'
    public static add = 'Add'
    public static addNote = 'Save Note'
    public static Note = 'Enter New Note'
    public static PickupNote = 'Edit Pick-up Note'
    public static DropoffNote = 'Edit Drop-off Note'
    public static deleteConfirmation = 'Are you sure you want to delete'
    public static description = 'Description'
    public static active = 'Active'
    public static archived = 'Archived'
    public static activate = 'Activate'
    public static activeDevice = 'Active Device'
    public static additionalInformation = 'Additional Information'
    public static addFunds = 'Add funds'
    public static addBonus = 'Add bonus'
    public static addFundsToWallet = 'Add funds to wallet'
    public static addBonusToWallet = 'Add bonus to wallet'
    public static addLocation = 'Add Location'
    public static addPromotion = 'Add Promotion'
    public static address = 'Address'
    public static addPaymentMethod = 'Add Payment Method'
    public static allowFreeAttendant = 'Allow a Free Attendant / Additional Rider'
    public static net = 'Net'
    public static amount = 'Amount'
    public static fee = 'Fee'
    public static archivedRiders = 'Archived riders'
    public static archivedDrivers = 'Archived drivers'
    public static assistance = 'Assistance'
    public static assistanceRequirements = 'Assistance Requirements'
    public static assistanceRequirementsTips = 'Tips about Assistance Requirements'
    public static attendant = 'Attendant'
    public static autoChargeIs = 'Auto charge is'
    public static autoChargeConfiguration = 'Auto charge configuration'
    public static ifBalanceFallsBelow = 'If the balance falls below'
    public static balance = 'Balance'
    public static basicInfo = 'Basic info'
    public static birthday = 'Birthday'
    public static cancel = 'Cancel'
    public static close = 'Close'
    public static color = 'Color'
    public static ok = 'Ok'
    public static confirm = 'Confirm'
    public static card = 'Card'
    public static cardHolderName = 'Card Holder Name'
    public static continueLabel = 'Continue'
    public static cost = 'Cost'
    public static create = 'Create'
    public static createNewRider = 'Create New Rider'
    public static createNewDriver = 'Create New Driver'
    public static createNewProduct = 'Create New Product'
    public static createNewOrganization = 'Create Organization'
    public static clearFilter = 'Clear Filters'
    public static editOrganization = 'Edit Organization'
    public static country = 'Country'
    public static currency = 'Currency'
    public static date = 'Date'
    public static deactivate = 'Deactivate'
    public static deleteLabel = 'Delete'
    public static removeLabel = 'Remove'
    public static deleteModalMessage = 'Are you sure you wish to delete this location?'
    public static deleteDesignatedZoneHotspotModalMessage = 'Are you sure you wish to delete this hotspot?'
    public static deleteDesignatedZoneModalMessage =
      'Are you sure you wish to delete this designated zone and its hotspots?'
    public static dropOff = 'Drop off'
    public static eligibilityForService = 'Eligibility for the Service'
    public static edit = 'Edit'
    public static email = 'Email'
    public static orca = 'Orca Serial Number'
    public static paymentMode = 'Payment Mode'
    public static preferredPaymentMethod = 'Preferred Payment Method'
    public static riderReferralCode = 'Rider Referral Code'
    public static enableAutoCharging = 'Enable auto charging'
    public static endDayAndTime = 'End date/time'
    public static failedRiderCreate = 'Failed to create Rider'
    public static failedOrganizationCreate = 'Failed to create Organization'
    public static fare = 'Fare'
    public static failed = 'Failed'
    public static price = 'Price'
    public static feedbackFromDispatcher = 'Feedback from dispatcher'
    public static finish = 'Finish'
    public static firstName = 'First Name'
    public static relationship = 'Relationship'
    public static history = 'History'
    public static inactive = 'Inactive'
    public static incomplete = 'Incomplete'
    public static alerts = 'Alerts'
    public static joinRequest = 'Join Request'
    public static lastName = 'Last Name'
    public static leavingTime = 'Leaving time'
    public static logo = 'Logo'
    public static label = 'Label'
    public static limitedDayAndTime = 'Limited day/time'
    public static loadingData = 'Loading Data ...'
    public static membership = 'Membership'
    public static membershipTips = 'Tips about Membership'
    public static mobility = 'Mobility'
    public static mobilityDevices = 'Mobility Devices'
    public static mobilityDevicesTips = 'Tips about Mobility devices and what is Active device. When Attendant ON/OFF.'
    public static mobilityOption = 'MobilityOption'
    public static mode = 'Mode'
    public static willCall = 'Will Call'
    public static willCallLabel = 'Add flexible return'
    public static willCallFilter = 'Flex Return'
    public static willCallExpired = 'Expired'
    public static unassigned = 'Requests'
    public static month = 'Month'
    public static createdAt = 'Created At'
    public static updatedAt = 'Updated At'
    public static deletedAt = 'Deleted At'
    public static before = 'Before'
    public static after = 'After'
    public static field = 'Field'
    public static search = 'Search'
    public static revenue = 'Revenue'
    public static recharge = 'Recharge'
    public static months = class {
      public static januaryShortName = 'Jan'
      public static februaryShortName = 'Feb'
      public static marchShortName = 'Mar'
      public static aprilShortName = 'Apr'
      public static mayShortName = 'May'
      public static juneShortName = 'June'
      public static julyShortName = 'July'
      public static augustShortName = 'Aug'
      public static septemberShortName = 'Sept'
      public static octoberShortName = 'Oct'
      public static novemberShortName = 'Nov'
      public static decemberShortName = 'Dec'
    }
    public static moveToActive = 'Move to Active'
    public static moveToInActive = 'Move to Inactive'
    public static moveToArchive = 'Move to Archive'
    public static restoreFromArchive = 'Restore from Archive'
    public static nameLabel = 'Name'
    public static none = 'None'
    public static note = 'Note'
    public static riderProfileNote = 'Shared Note'
    public static riderProfileInternalNote = 'Internal Note'
    public static riderProfileNotePlaceHolder =
      'Note to Provider displayed at the first location. Example: Spanish speaking, arm assist, uses a walker.'
    public static riderProfileInternalNotePlaceHolder = 'Internal note shared with same organizations'
    public static off = 'Off'
    public static on = 'On'
    public static notificationSetting = 'Notification setting'
    public static numberOfRides = 'Number of rides'
    public static optional = 'Optional'
    public static paymentMethod = 'Payment Method'
    public static paymentMethods = 'Payment Methods'
    public static paymentMethodTips = 'Tips about payment method.'
    public static paypal = 'Paypal'
    public static permanent = 'Permanent'
    public static profile = 'Rider Profile'
    public static profileInfoTips = ''
    public static organizationInfo = 'Organization Info'
    public static organizationInfoTips = 'Tips about Organization'
    public static organizationSetting = 'Organization Setting'
    public static legalEntityTips = 'Tips about Legal Entity'
    public static bankAccountTips = 'Tips about Bank Account'
    public static organizationServiceArea = 'Service Area'
    public static personalInfo = 'Personal Info'
    public static personalInfoTips =
      'First name, last name, email, phone number are required. Other fields are optional'
    public static phoneNumber = 'Phone Number'
    public static latitude = 'Latitude'
    public static longitude = 'Longitude'
    public static photo = 'Photo'
    public static pickUp = 'Pick up'
    public static previousStep = 'Previous Step'
    public static primary = 'Primary'
    public static rechargeBalanceTo = 'Recharge in the amount of'
    public static recurring = 'Recurring'
    public static riders = 'Riders'
    public static ridersList = 'Riders list'
    public static driversList = 'Drivers list'
    public static ridesPer = 'rides per'
    public static role = 'Role'
    public static save = 'Save'
    public static legalEntity = 'Legal Entity'
    public static subscriptionPlan = 'Subscription Plan'
    public static bankAccount = 'Bank Account'
    public static saveLocation = 'Save Location'
    public static savedLocations = 'Saved Locations'
    public static savedPaymentMethod = 'Saved Payment Method'
    public static savedPaymentMethods = 'Saved Payment Methods'
    public static savePersonalInfoBeforeContinue = 'Save personal info before continuing'
    public static saveOrganizationInfoBeforeContinue = 'Save organization info before continuing'
    public static saving = 'Saving...'
    public static secondary = 'Secondary'
    public static skip = 'Skip'
    public static startDayAndTime = 'Start date/time'
    public static status = 'Status'
    public static tags = 'Tags'
    public static temporary = 'Temporary'
    public static textMessage = 'Text message, the default setting'
    public static tips = 'Tips'
    public static title = 'Title'
    public static totalTrips = 'Total trips'
    public static transactionId = 'Transaction ID'
    public static tripId = 'Trip ID'
    public static travelDistance = 'Travel distance'
    public static travelTime = 'Travel time'
    public static type = 'Type'
    public static unlimited = 'Unlimited'
    public static update = 'Update'
    public static username = 'Username'
    public static voice = 'Voice, automated call for landline'
    public static wallet = 'Wallet'
    public static promotions = 'Promotions'
    public static walletBalance = 'Wallet Balance'
    public static walletTransactions = 'Wallet Transactions'
    public static fullHistory = 'Full History'
    public static transactionInitiator = 'Initiated by'
    public static transactionMessage = 'Reason'
    public static wasRequesting = 'Was requesting'
    public static wasWaitingForPickUp = 'Was waiting for pickup'
    public static website = 'Website'
    public static week = 'Week'
    public static wheelchair = 'Wheelchair'
    public static year = 'Year'
    public static by = 'By'
    public static refund = 'Refund'
    public static scheduleRecurringRide = 'Schedule Recurring Ride'
    public static designatedHotspot = 'Designated Hotspot'
    public static enabled = 'Enabled'
    public static zone = 'Zone'
    public static zoneType = 'Zone Type'
    public static pin = 'Pin'
    public static latNlng = 'Lat and Lng'
    public static group = 'Group'
    public static scheduleReturnRide = 'Add schedule return'
  }

  public static driver = class {
    public static checkInTime = 'Check in time'
    public static checkOutTime = 'Check out time'
    public static duration = 'Duration'
    public static estimatedDuration = 'Estimated Duration'
    public static personalInfo = class {
      public static errorOnUpdate = 'There was an error saving Personal Info changes'
    }
    public static driverSessionsHeaderDefinitions = class {
      public static Date = 'The date when the specific session took place'
      public static checkIn = 'The time that the driver checked-in'
      public static service = 'Time taken for a trip to complete from Accepted to Completed status'
      public static trip = 'Time taken for a trip to complete from Driving to pickup to Arrived at dropoff status'
      public static driving = 'Total time spent from Arrived at pickup to Arrived at dropoff status'
      public static estimated = 'Estimated trip duration by Google'
      public static distancemi = 'The total distance (in miles) covered by all the trips in a day'
      public static ctc = 'The total number of trips completed by the driver in a day'
      public static atc = 'The total number of trips assigned to a driver in a day'
      public static fare = 'The amount of fare accumulated from all the trips made in a day'
      public static revenue = 'The amount of revenue accumulated from all the trips made in a day'
      public static totalBreakHours = 'Total breaks hours taken by the driver in a day'
    }

    public static clockedIn = 'Clocked In (Stand by)'
    public static driverClockedIn = 'Clocked In'
    public static label = 'Label'
    public static total = 'Total'
    public static checkInCoordinates = 'Check-in Coordinates'
    public static checkOutCoordinates = 'Check-out Coordinates'
    public static distanceTraveled = 'Distance Traveled'
    public static dispatch = 'Dispatch (Work Time)'
    public static breakTIme = 'Break (Break Time)'
    public static afterHours = 'After Hours'
    public static deleteModalMessage = 'Are you sure you wish to delete this session?'
    public static validation = class {
      public static firstNameIsRequired = 'First Name is required'
      public static lastNameIsRequired = 'Last Name is required'
      public static firstNameIsInvalid = 'First Name is invalid'
      public static usernameIsRequired = 'Username is required'
      public static invalidEmailAddress = 'Invalid email address'
      public static emailAddressIsRequired = 'Email address is requried'
      public static phoneNumberInvalid = 'Phone number invalid'
      public static phoneNumberIsRequired = 'Phone number is required'
      public static birthDateIsRequired = 'Birth date is required'
      public static driversLicense = `Driver's License Number must not exceed 16 characters.`
    }
  }

  public static organization = class {
    public static bankAccount = class {
      public static accountHolderName = 'Account Holder Name'
      public static accountHolderType = 'Account Holder Type'
      public static accountNumber = 'Account Number'
      public static addBankAccount = 'Add Bank Account'
      public static connectedBankAccounts = 'Connected Bank Accounts'
      public static routingNumber = 'Routing Number'
      public static successfullyRemoved = 'Bank Account was removed successfully'
      public static successfullyUpdated = 'Bank Account was saved successfully'
      public static successfullySetDefault = 'Bank Account was successfully set as primary'
      public static errorOccurred = 'An error occurred'
      public static setPrimary = 'Set as primary'
      public static deleteAccount = 'Delete Account'
      public static warning = 'Warning!'
      public static deleteConfirmation = 'Are you sure want to delete'
      public static deleteFail = 'You cannot delete the primary account.'
      public static validation = class {
        public static accountHolderNameIsMissing = 'Account Holder Name is Missing'
        public static accountNumberIsMissing = 'Account Number is Missing'
        public static accountNumberIsInvalid = 'Account Number is Invalid'
        public static legalEntityRequired = 'Unable to add Bank Account, Legal Entity details are required.'
        public static routingNumberIsMissing = 'Routing Number is Missing'
        public static routingNumberIsInvalid = 'Routing Number is Invalid'
        public static routingNumberMustHave9Digits = 'Routing Number must have 9 digits'
      }
    }
    public static organizationInfo = class {
      public static successfullyUpdated = 'Organization was saved successfully'
      public static errorOnSave = 'There was an error saving Orgnaization'
      public static serviceAreaNameisMissing = 'Service Area Name is Missing'
      public static timeZone = 'Time Zone'
      public static timeFormat = 'Time Format'
      public static sendEmail = 'Send email receipt for requests'
      public static callerID = 'Caller ID'
    }
    public static legalEntity = class {
      public static addressLine1 = 'Address Line 1'
      public static addressLine2 = 'Address Line 2'
      public static agreedToTerms = 'You must agree with terms and condition before continuing'
      public static businessName = 'Business Name'
      public static businessTaxId = 'Business Tax ID'
      public static city = 'City'
      public static iAgreeToThe = 'I agree to the'
      public static postalCode = 'Postal Code'
      public static state = 'State'
      public static successfullyUpdated = 'Legal Entity was saved successfully'
      public static termsAndConditions = 'terms and conditions'
      public static type = 'Organization Type'
    }
    public static validation = class {
      public static addressLine1IsMissing = 'Address line 1 is missing'
      public static addressLine2IsMissing = 'Address line 2 is missing'
      public static businessNameIsMissing = 'Business name is missing'
      public static cityIsMissing = 'City is missing'
      public static firstNameIsMissing = 'First name is missing'
      public static lastNameIsMissing = 'Last name is missing'
      public static postalCodeIsMissing = 'Postal code is missing'
      public static stateIsMissing = 'State is missing'
    }
  }

  public static rider = class {
    public static externalMemberId = 'Membership ID'
    public static activity = 'Activity'
    public static bookNewRide = 'Book new ride'
    public static recent = 'Recent'
    public static upcoming = 'Upcoming'

    public static recurringTrips = class {
      public static plannedTrips = 'Planned Trips'
      public static recurringRides = 'Recurring Trips'
      public static upcomingTrips = 'Upcoming Trips'
    }

    public static labels = class {
      public static organizationDropdown = 'Organization'
      public static phoneNumberAlreadyExistModalTitle = 'Phone number already exist'
    }
    public static assistance = class {
      public static errorOnFetching = ''
      public static errorOnUpdate = 'There was an error saving Assistance'
      public static successfullyFetched = ''
      public static successfullyUpdated = 'Assistance was saved successfully'
    }
    public static list = class {
      public static errorOnFetching = ''
      public static successfullyFetched = ''
    }
    public static location = class {
      public static errorOnFetching = ''
      public static errorOnUpdate = 'There was an error saving Saved locations'
      public static noLocation = 'No location'
      public static successfullyFetched = ''
      public static successfullyCreated = 'Location was created successfully'
      public static successfullyUpdated = 'Saved locations were saved successfully'
      public static successfullyDeleted = 'Location was deleted successfully'
    }
    public static locations = 'Locations'
    public static locationActivity = 'Location Activities'
    public static membership = class {
      public static errorOnFetching = ''
      public static errorOnSuspend = ''
      public static errorOnUpdate = 'There was an error saving Membership'
      public static successfullyFetched = ''
      public static successfullySuspended = ''
      public static successfullyUpdated = 'Membership was saved successfully'
    }
    public static mobility = class {
      public static errorOnFetching = ''
      public static errorOnUpdate = 'There was an error saving Mobility'
      public static successfullyFetched = ''
      public static successfullyUpdated = 'Mobility was saved successfully'
    }
    public static payment = class {
      public static makeDefault = 'Make default'
      public static successfullyAdded = 'Payment source was added successfully'
      public static successfullyRemoved = 'Payment source was successfully removed'
      public static nearingExpiry = 'Card Expiring'
      public static expired = 'Card Expired'
      public static addOnCreate = 'Create Add On'
      public static addOnLabel = 'Add On Label'
      public static addOnPrice = 'Add On Price'
      public static mode = class {
        public static multiple = 'Multiple'
        public static cash = 'Cash'
        public static wallet = 'Wallet'
      }
    }
    public static personalInfo = class {
      public static errorOnCreate = 'There was an error saving Personal Info'
      public static errorOnFetching = ''
      public static errorOnUpdate = 'There was an error saving Personal Info changes'
      public static successfullyCreated = 'Personal Info was saved successfully. You may continue to the next step'
      public static successfullyFetched = ''
      public static successfullyUpdated = 'Personal Info changes were saved successfully'
    }
    public static status = class {
      public static errorOnActivate = ''
      public static errorOnArchive = ''
      public static errorOnDeactivate = ''
      public static successfullyActivated = ''
      public static successfullyArchived = 'Successfully archived rider'
      public static successfullyRestored = 'Successfully restored rider to active'
      public static successfullyDeactivated = ''
    }
    public static validation = class {
      public static invalidEmailAddress = 'Invalid email address'
      public static fillAllRequiredFields = 'Fill in all required fields'
      public static invalidName = 'Provide a valid first name and last name'
      public static firstNameIsRequired = 'First Name is required'
      public static lastNameIsRequired = 'Last Name is required'
      public static firstNameIsInvalid = 'First Name is invalid'
      public static lastNameIsInvalid = 'Last Name is invalid'
      public static timeZoneIsRequired = 'Time Zone is required'
      public static stateIsRequired = 'State is required'
      public static phoneNumberIsRequired = 'Phone Number is required'
      public static usernameIsRequired = 'Username is required'
      public static nameIsMissing = 'Category is missing'
      public static orgNameIsRequired = 'Organization name is required'
      public static locationAddressMinLength = 'Address must be at least 3 character.'
      public static locationNameMinLength = 'Category must be at least 1 character.'
      public static locationOrderIdTaken = 'This order ID is already taken'
      public static membershipRecurringMonthsMinLength =
        "All Memberships with 'Recurring' as a Temporary must have at least one month"
      public static selectValidLocationOrderId = 'Select a valid order ID for the new location.'
      public static organizationOwnerIsRequired = 'Organization owner is required'
      public static categoryIsPresent = 'Category is already present'
      public static birthDateIsRequired = 'Birthdate is required'
      public static phoneNumberInvalid = 'Phone number invalid'
      public static needsOneMembersip = 'One Membership needed'
      public static driversLicense = `Driver's License Number must not exceed 16 characters.`
      public static caregiverRelationshipIsRequired = 'Caregiver relationship is required'
      public static caregiverContactNumberIsRequired = 'Caregiver contact number is required'
      public static caregiverEmailAddressIsRequired = 'Caregiver emaill address is required'
    }
    public static defaultValues = class {
      public static organization = {
        label: 'Choose organization owner',
        value: 'noOrganization'
      }
    }
    public static wallet = class {
      public static errorOnAddFunds = ''
      public static errorOnAutocharge = ''
      public static errorOnUpdate = 'There was an error saving Wallet'
      public static successfullyAddedFunds = ''
      public static successfullyAutocharged = ''
      public static successfullyUpdated = 'Wallet was saved successfully'
      public static successfullyRefunded = 'Refunded successfully'
      public static successfullyRechargedWallet =
        'Re-charge has been completed. Please check on stripe if payment was transferred successfully.'
    }

    public static changeLog = class {
      public static riderChangeLog = 'Rider Change Log'
    }

    public static feedback = class {
      public static driverFeedback = 'Driver Feedback'
      public static riderFeedback = 'Rider Feedback'
    }
  }

  public static tripStatusMap = {
    REQUESTED: 'Requested',
    ACCEPTED: 'Accepted',
    CANCELLED: 'Cancelled',
    DRIVER_CANCELLED: 'Driver Cancelled',
    RIDER_CANCELLED: 'Rider Cancelled',
    CANCEL_BILLABLE: 'Cancelled Billable',
    REJECTED: 'Rejected',
    BOOKING_FAILED: 'Booking failed.',
    INTEGRATION_FAILED: 'Connection lost',
    NO_RESPONSE_OPERATOR: 'No response',
    COMPLETED: 'Completed',
    MANUALLY_COMPLETED: 'Manually Completed',
    ARRIVED_AT_PICK_UP: 'Arrived at pickup',
    DRIVING_TO_PICK_UP: 'Driving to pickup',
    PICKED_UP: 'Passenger loaded',
    DRIVING_TO_DROP_OFF: 'Driving to dropoff',
    ARRIVED_AT_DROP_OFF: 'Arrived at dropoff',
    SCHEDULED: 'Scheduled',
    SCHEDULE_REQUESTED: 'Schedule requested',
    SCHEDULE_ACCEPTED: 'Schedule accepted',
    WAITING: 'Waiting',
    NO_SHOW_RIDER: 'No Show Rider',
    DISPATCH_ASSIGNED_DRIVER: 'Dispatch Assigned Driver',
    WILL_CALL: 'Will Call',
    EXPIRED: 'Expired',
    PENDING: 'Pending',
    COMPLETED_PENDING_PAYMENT: 'Pending Payment'
  }
  public static tripStatusHoverMessageMap = {
    REQUESTED: '',
    ACCEPTED: '',
    CANCELLED: '',
    DRIVER_CANCELLED: '',
    RIDER_CANCELLED: '',
    CANCEL_BILLABLE: '',
    REJECTED: '',
    BOOKING_FAILED: 'Request not sent.',
    INTEGRATION_FAILED: 'Contact provider for updates to sent request.',
    NO_RESPONSE_OPERATOR: '',
    COMPLETED: '',
    MANUALLY_COMPLETED: '',
    ARRIVED_AT_PICK_UP: '',
    DRIVING_TO_PICK_UP: '',
    PICKED_UP: '',
    ARRIVED_AT_DROP_OFF: '',
    SCHEDULED: '',
    SCHEDULE_REQUESTED: '',
    SCHEDULE_ACCEPTED: '',
    WAITING: '',
    NO_SHOW_RIDER: '',
    DISPATCH_ASSIGNED_DRIVER: '',
    WILL_CALL: '',
    EXPIRED: '',
    COMPLETED_PENDING_PAYMENT: ''
  }

  public static trip = class {
    public static id = 'Trip ID'
    public static averageAcceptTime2Minutes = 'Average accept time 2 minutes'
    public static cancelRequest = 'Cancel Request'
    public static changeStatus = 'Change Status'
    public static destinationArrival = 'Destination Arrival'
    public static estimatedPickup = 'Estimated Pickup'
    public static estimatedLoadingTime = 'Estimated Loading/Unloading Time'
    public static findingYouARide = 'Finding you a ride'
    public static noTrip = 'no trip'
    public static rating = 'Rating'
    public static riderAccepted = 'Ride accepted'
    public static assign = 'Assign'
    public static transfer = 'Transfer'
    public static disableAutoRefresh = 'Disable Auto Refresh'
    public static enableAutoRefresh = 'Auto Refresh'
    public static showTrips = 'Show Trips'
    public static generateRecurringTrips = 'Generate Recurring Trips'
    public static service = 'Service'
    public static product = 'Product'
    public static distance = 'Distance'
    public static tripDetailsSharedWithContacts = 'Trip details shared with contacts'
    public static copyAndAssign = 'Cancel and Reassign'
    public static copyAndCancel = 'Copy and Cancel'
    public static scheduledPickUpTime = 'Pickup Time'
    public static scheduledDropOffTime = 'Drop Off Time'
    public static returnPickUpTime = 'Return Pickup Time'
    public static groupTrips = 'Group Trips'
    public static statuses = class {
      public static accepted = 'Accepted'
      public static canceled = 'Cancelled'
      public static cancelBillable = 'Cancel Billable'
      public static rejected = 'Rejected'
      public static bookingFailed = 'Booking Failed'
      public static integrationFailed = 'Integration Failed'
      public static noResponse = 'No response'
      public static completed = 'Completed'
      public static enRoute = 'En route'
      public static requesting = 'Requesting'
      public static scheduleRequested = 'Submitted for scheduling'
      public static scheduleAccepted = 'Accepted for scheduling'
      public static scheduled = 'Scheduled'
      public static waitingForAccept = 'Waiting for accept'
      public static waitingForPickUp = 'Waiting for pick-up'
      public static willCallLater = 'Awaiting Will Call'
      public static pending = 'Pending'
    }
    public static recurringTrips = class {
      public static runForever = 'Does this End? '
      public static schedDays = 'Days to sched: '
      public static timeToRecur = 'Times to Repeat'
      public static doesntEnd = `Doesn't End`
    }
    public static ungroupTrips = class {
      public static confirm = 'Confirm'
      public static ungroupTripsPerServiceMessage =
        'Are you sure you want to ungroup scheduled trips under this service?'
      public static title = 'Ungroup Trips'
    }
  }

  public static manualGroupTrips = class {
    public static groupTrips = 'Group Trips'
    public static manuallyGroupTrips = 'Manually Group Trips'
  }

  public static vehicle = class {
    public static passengerSeats = 'Passenger Seats'
    public static wheelchair = 'Wheelchair'
    public static cot = 'COT'
    public static VEHICLES = 'VEHICLES'
    public static DEACTIVATED_VEHICLES = 'DEACTIVATED VEHICLES'
  }

  public static product = class {
    public static productName = 'Product name'
    public static productDescription = 'Description'
    public static serviceLevel = 'Service Level'
    public static integrationStatus = 'Integration Status'
    public static status = 'Status'
    public static productInfo = 'Product Info'
    public static productIntegration = 'Product Integration'
    public static productPricing = 'Product Pricing'
    public static PRODUCTS = 'PRODUCTS'
    public static DEACTIVATED_PRODUCTS = 'DEACTIVATED PRODUCTS'
  }

  public static service = class {
    public static viewOption = 'View Options'
    public static serviceInfo = 'Service info'
    public static autoDispatch = 'Auto Dispatch'
    public static serviceName = 'Service Name'
    public static serviceProgram = 'Service Program'
    public static internalName = 'Internal Name'
    public static serviceDes = 'Service Description'
    public static phoneNumber = 'Phone Number'
    public static membershipReq = 'Membership Required'
    public static tripLimit = 'Trip Limit'
    public static publicService = 'Viewable to Public'
    public static privateService = 'Invite Only'
    public static signatureCollection = 'Signature Collection Required'
    public static serviceOptions = 'Service Options'
    public static enableDesignatedHotspots = 'Designated Hotspots'
    public static generate = 'Generate'
    public static groupRide = 'Group Ride'
    public static multipleStop = 'Multiple Stop'
    public static designatedHotspots = 'Designated Hotspots'
    public static hideService = 'Hide Service'
    public static groupSettingLabels = class {
      public static ondemandPickupRadius = 'Ondemand Pick-up Radius'
      public static ondemandDropoffRadius = 'Ondemand Drop-off Radius'
      public static scheduledPickupRadius = 'Scheduled Pick-up Radius'
      public static scheduledDropoffRadius = 'Scheduled Drop-off Radius'
      public static scheduledPickupTime = 'Scheduled Pick-up Time'
      public static scheduledDropoffTime = 'Scheduled Drop-off Time'
      public static allowGroupingDifferentProducts = 'Allow grouping of different products'
    }
    public static notificationMessage = 'Notification Message'
    public static notificationOptions = 'Notification Options'
    public static onDemandTripReminder = 'On Demand Reminder'
    public static scheduledTripReminder = 'Scheduled Trip Reminder'
    public static willCallTripReminder = 'Will Call Trip Reminder'
    public static requestTimeoutDuration = 'Request Timeout Duration (mins)'
    public static allowMobileRequest = 'Allow Mobile App Request'
    public static maxTravelDistance = 'Max Travel Distance (meter)'
    public static rideReconfirmation = 'Ride Reconfirmation (seconds)'
    public static allottedWaitingTime = 'Allotted Waiting Time'
  }
  public static manualTripComplete = class {
    public static menuItemLabel = 'Manual Complete'
    public static modalTitle = 'Force change in status'
    public static submitButton = 'Submit'
    public static completionTypeLabel = 'Mark as'
    public static tripPriceLabel = 'Amount to charge ($)'
    public static completionReasonLabel = 'Reason for manual complete'
    public static notificationControlLabel = 'Send Notification'
  }

  public static optimizeTrip = class {
    public static modalTitle = 'Optimize Trips'
    public static routeOptimizer = 'Route Optimizer'
    public static triggerButtonLabel = 'Optimize Trips'
  }

  public static cancelBillable = class {
    public static modalTitle = 'Cancel Billable'
    public static submitButton = 'Submit'
    public static reasonQuestion = 'Choose the reason for trip cancellation'
    public static cancelReasons = [
      'Could not find',
      'No answer at door',
      'No answer by phone',
      'Refused on arrival',
      'Wrong location',
      'Not ready'
    ]
  }

  public static manualTripCancel = class {
    public static menuItemLabel = 'Cancel'
    public static modalTitle = 'Cancel Request'
    public static reasonQuestion = 'Choose the reason for trip cancellation'
    public static cancelReasons = [
      "Can't find rider",
      'Traffic',
      'Mechanical vehicle issue',
      'Vehicle capacity (not enough seats)',
      'Vehicle capability to accomodate',
      'Other'
    ]
  }

  public static manualTripNoShow = class {
    public static menuItemLabel = 'No Show'
    public static reasonQuestion = 'Add Reason'
    public static modalTitle = 'Trip No Show'
    public static noShowReasons = [
      'Could not find',
      'No answer at door',
      'No answer by phone',
      'Refused on arrival',
      'Wrong location',
      'Not ready'
    ]
  }

  public static promotions = class {
    public static titleLabel = 'Code'
    public static promotion = 'Promotion'
    public static promotionTypeLabel = 'Promotion Type'
    public static promotionValueLabel = 'Value of Promotion'
    public static maxRedemptionsLabel = 'Maximum number of redemptions'
    public static expiresAtLabel = 'Expires At'
    public static serviceLabel = 'Service'
    public static validation = class {
      public static required = 'Required'
      public static promotionCodeError = 'The promotion code is required.'
      public static promotionValueError = 'The value of the promotion should be more than zero.'
      public static promotionRedemptionError = 'The maximum number of redemptions should be one or more.'
      public static promotionExpiryAt = 'The expiry date is required.'
    }
  }
  public static stationUser = class {
    public static archivedStationUser = 'Archived Station User'
    public static addServiceZone = 'Add Service Zone'
    public static createStationUser = 'Create New Station User'
    public static goinZones = 'Goin Zones'
    public static stationUser = 'Station User'
    public static stationUserTips = 'Tips about Station User'
    public static userInfo = 'User Info'
  }

  public static teamMember = class {
    public static archivedTeamMembers = 'Archived Team Members'
    public static archivingUnarchivingMessage = 'Team member successfully archived/unarchived.'
    public static createNewTeamMember = 'Create New Team Member'
    public static createTeamMember = 'Create Team Member'
    public static editTeamMember = 'Edit Team Member'
    public static invitationMessage =
      'Invitation sent to team member email. Please check all email folders including spam.'
    public static moveToArchive = 'Move to Archive'
    public static permission = 'Permission'
    public static personalInfo = 'Personal Info'
    public static resetPassword = 'Reset Password'
    public static resetPasswordMessage = 'Password reset link has been sent to your registered email.'
    public static restoreFromArchive = 'Restore from Archive'
    public static roles = 'Roles'
    public static sendInvite = 'Send Invite'
    public static teamMembers = 'Team Members'
    public static tipsAboutTeamMembers = 'Tips about Team Members'
    public static form = class {
      public static email = 'Email'
      public static firstName = 'First Name'
      public static lastName = 'Last Name'
      public static organization = 'Organization'
      public static phoneNumber = 'Phone Number'
      public static username = 'Username'
      public static permission = class {
        public static billingManagement = 'Billing Management'
        public static drivers = 'Drivers'
        public static globalSettings = 'Global Settings'
        public static organizationInfo = 'Organization Info'
        public static products = 'Products'
        public static promotions = 'Promotions'
        public static resources = 'Resources'
        public static riderDriverFeedbacks = 'Rider / Driver Feedbacks'
        public static riders = 'Riders'
        public static service = 'Service'
        public static services = 'Services'
        public static servicesPlaceholder = 'Please select services...'
        public static stationUser = 'Station User'
        public static teamMembers = 'Team Members'
        public static tripsManagement = 'Trips Management'
        public static vehicles = 'Vehicles'
      }
    }
  }

  public static riderPortal = class {
    public static auth = class {
      public static accessYourAccount = 'Sign in to access your account, book rides, and manage your profile.'
      public static enterOtp = 'Enter your One-Time Password'
      public static invalidPhoneNumber = 'Invalid phone number'
      public static otpRecipient = 'One-Time Password Recipient'
      public static rememberMe = 'Remember me for 30 days'
      public static resendOTP = 'Resend One-Time Password'
      public static sendOTP = 'Send One-Time Password'
      public static sendOTPtoEmail = 'Send one-time password to registered email'
      public static signIn = 'Sign In'
      public static signinToAccount = 'Sign In To Your Account'
      public static sms = 'SMS'
      public static welcomeBack = 'Welcome Back'
    }
    public static footer = class {
      public static aboutUs = 'About Us'
      public static accessibility = 'Accessibility'
      public static allRightsReserved = 'All rights reserved'
      public static contactInfo = 'Contact Info'
      public static contactUs = 'Contact Us'
      public static flow = 'Flow'
      public static goin = "GOIN'"
      public static goinMyWay = "GOIN' My Way"
      public static goinTransitFlowPro = "GOIN' Transit Flow Pro"
      public static faq = 'FAQ'
      public static home = 'Home'
      public static quickLinks = 'Quick Links'
      public static ourProducts = 'Our Products'
      public static privacy = 'Privacy'
      public static privacyPolicy = 'Privacy Policy'
      public static products = 'Products'
      public static tagLine = 'Reimagining community mobility with innovative and transit solutions.'
      public static terms = 'Terms'
      public static termsOfService = 'Terms of Service'
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/ui-messages.ts